import { Modal, WImage, WLink } from '@components/atoms'
import { useState } from 'react'
import { CollezioneItemType } from '../../../utils/types'
import { ArrowRightUp, Close } from '../../icons'
import styles from './CardCollezione.module.sass'

interface Props {
  item:
    | CollezioneItemType['colori'][0]['tonalita'][0]
    | CollezioneItemType['decori'][0]['decori'][0]
  className?: string
  variant?: 'colori' | 'decori'
  onClickColore?: (item: any) => void
}

const CardCollezione = (props: Props) => {
  const { item = undefined, className = '', variant = 'colori', onClickColore = undefined } = props
  const [isOpen, setIsOpen] = useState(false)

  const cardContent = (
    <div className={`${styles.layout}`}>
      <div className={`${styles.imageBox}`}>
        {item.image.url && (
          <WImage
            src={item.image.url}
            maxWidth={190}
            maxHeight={190}
            objectFit={variant === 'colori' ? 'cover' : 'contain'}
            alt={item?.imageAlt}
            title={item.alt}
          />
        )}
      </div>
      <div className={styles.main}>
        {(item.nome || item.nomeWeb) && (
          <>
            <div className={styles.content}>
              <p className={styles.title}>{item.nome || item.nomeWeb}</p>
              <ArrowRightUp className={styles.icon} />
            </div>
            {item.finitura && <p className={styles.colorDetails}>{item.finitura}</p>}
            {item.collezioni && <p className={styles.colorDetails}>{item.collezioni}</p>}
          </>
        )}
      </div>
    </div>
  )

  return item ? (
    <div className={`${styles.root} ${className} ${styles[`root--${variant}`]}`}>
      {variant === 'colori' ? (
        <WLink href={item.url} onClick={() => onClickColore(item?.url)}>
          {cardContent}
        </WLink>
      ) : (
        <button onClick={() => setIsOpen(true)}>{cardContent}</button>
      )}
      <Modal
        id={'decori-preview'}
        open={isOpen}
        onClose={() => setIsOpen(false)}
        className={styles.modal}
      >
        <div className={styles.modalCloseProva} onClick={() => setIsOpen(false)}>
          <Close />
        </div>
        <div className={styles.modalImageBox}>
          <WImage
            src={item.image.url}
            maxWidth={560}
            maxHeight={560}
            objectFit="contain"
            alt={item?.imageAlt}
            title={item.alt}
          />
        </div>
      </Modal>
    </div>
  ) : (
    <></>
  )
}

export default CardCollezione
